import axiosInstance from '../axiosInterceptor/axiosInstance'

const getTeams = async (orgId, { gender, ageRestriction } = {}) => {
  const params = new URLSearchParams()
  if (gender != null) params.append('gender', gender)
  if (ageRestriction != null) params.append('ageRestriction', ageRestriction)
  const query = params.toString()
  const response = await axiosInstance.get(`v1/orgs/${orgId}/teams${query ? `?${query}` : ''}`)
  return response?.data
}

export default getTeams
